<script setup lang="ts">
import { ArticleUnit } from '@/generated/graphql'
import ArticleUnitTag from '@/components/article/ArticleUnitTag.vue'

const props = defineProps<{
  milliQuantity?: number
  unit?: ArticleUnit
  unitAbbreviated?: boolean
}>()
</script>

<template>
  {{ props.milliQuantity ? props.milliQuantity / 1000 : '-' }}
  <article-unit-tag
    v-if="props.unit"
    :model-value="props.unit"
    :abbreviated="props.unitAbbreviated"
  />
</template>

<style scoped lang="scss"></style>
